import { useContext, useEffect, useState } from 'react';
import api from '../../../api';
import MarketingNotificationModal from '../MarketingNotificationModal';
import ModalContext from '../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import IdentityContext from '../../../contexts/IdentityContext';
import AccountContext from '../../../contexts/AccountContext';
import { MarketingNotification } from '../MarketingNotificationModal';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';

export default function useMarketingNotifications({
  newDigibookOnly,
  moduleId,
}: {
  newDigibookOnly?: boolean;
  moduleId?: string;
} = {}) {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;
  const { account } = useContext(AccountContext);
  const loginProvider = account.provider;

  const {
    i18n: { language },
  } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const {
    identity: { isAuthenticated },
  } = useContext(IdentityContext);
  const [marketingNotifications, setMarketingNotifications] = useState<MarketingNotification[]>([]);
  const handleError = useThrowAsyncError();

  useEffect(() => {
    const fetchMarketingNotifications = async () => {
      const {
        data: { data: notifications },
      } = await api.get<{ data: MarketingNotification[] }>(
        `/studio/user/${REACT_APP_P_STUDIO_GROUP}/marketing-notifications`,
        {
          params: {
            loginProvider,
            language,
            ...(newDigibookOnly ? { newDigibookOnly } : {}),
            ...(moduleId ? { module: moduleId } : {}),
          },
        },
      );

      setMarketingNotifications(notifications);
    };

    if (isAuthenticated && loginProvider) {
      fetchMarketingNotifications().catch(handleError);
    }
  }, [REACT_APP_P_STUDIO_GROUP, language, loginProvider, handleError, newDigibookOnly, moduleId, isAuthenticated]);

  useEffect(() => {
    /*
      The marketing notifications are sent to the modalContext in reverse order to
      preserve the API order: last one on the stack is the first one to be displayed.
    */
    marketingNotifications.reverse().forEach(notification => {
      showModal(<MarketingNotificationModal id={notification.id} notification={notification} />);
    });
  }, [marketingNotifications, showModal]);
}
